<template>
  <ContentSection>
    <Container>
      <div class="text-center">
        <iframe
          :src="iframeSrc"
          width="100%"
          height="800"
          frameborder="0"
          scrolling="no"
          allowtransparency
          allowfullscreen
          style="margin: 0 auto"
        />
      </div>
    </Container>
  </ContentSection>
</template>

<script setup lang="ts">
const props = defineProps<{
  data: {
    code: string
  }
}>()

const iframeSrc = computed(
  () => `https://v.calameo.com/?bkcode=${props.data.code}&mode=mini`
)
</script>
